import { apiQuestions } from '@/lib';
import { useQuery } from 'react-query';

interface useGetPatientQuestionResponsesProps {
  results: any[];
  publicacaoId: string;
}

const useGetUsuarioDisparosQuiz = ({
  results,
  publicacaoId,
}: useGetPatientQuestionResponsesProps) => {
  const { data, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['patient-quizz-disparos', results, publicacaoId],
    queryFn: async () => {
      const resultsComRespostas = await Promise.all(
        results
          .filter(
            (r: { publicacaoId: string }) => r.publicacaoId === publicacaoId,
          )
          .map(async (item: any) => {
            const { data: respostas } = await apiQuestions.get(
              `publicacao/resposta-by-disparo/${item.disparoId}`,
            );
            return {
              ...item,
              respostas,
            };
          }),
      );

      return resultsComRespostas;
    },
    enabled: !!results?.length && !!publicacaoId,
  });

  return {
    data,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
};

export default useGetUsuarioDisparosQuiz;
